import request from '@/utils/request.js'

/***客户管理列表***/
export function getAgentList(data){
    return request({
        url: 'sysUser/agent/list',
        method: 'post',
        data
    })
}

export function getSimPkgList(data){
    return request({
        url: 'pkg/update/total/list',
        method: 'post',
        data
    })
}
export function getUpdatePkgList(data){
    return request({
        url: 'pkg/update/total/data',
        method: 'post',
        data
    })
}


export function getPkgList(data){
    return request({
        url: 'pkg/list',
        method: 'post',
        data
    })
}

export function getAgentListforCardDistube(data){
    return request({
        url: 'agent/all',
        method: 'post',
        data
    })
}
export function addNewPkg(data){    
    return request({
        url: 'pkg/insert',
        method: 'post',
        data
    })
}
export function updateNewPkg(data){    
    return request({
        url: 'pkg/update',
        method: 'post',
        data
    })
}
/***新增代理商***/
export function addNewAgent(data){    
    return request({
        url: 'sysUser/agent/insert',
        method: 'post',
        data
    })
}
/***修改代理商信息***/
export function updateAgentInfo(data){    
    return request({
        url: 'sysUser/agent/update',
        method: 'post',
        data
    })
}
export function updateAgentInfo1(data){    
    return request({
        url: 'agent/updateSms/info',
        method: 'post',
        data
    })
}
export function updateAgentInfo2(data){    
    return request({
        url: 'agent/updateAccount/info',
        method: 'post',
        data
    })
}
export function updateAgentInfo3(data){    
    return request({
        url: 'agent/updateAccount/voice',
        method: 'post',
        data
    })
}


/** 重置密码 **/
export function doResetPassword(data){    
    return request({
        url: 'sysUser/sys/pwd',
        method: 'post',
        data
    })
}


/** 更新短信授权 **/
export function doUpdateSMSPermissions(data){    
    return request({
        url: 'sysUser/update/sms/state',
        method: 'post',
        data
    })
}

/*** 删除客户 */
export function deleteCustomer(data){
    return request({
        url: 'sysUser/agent/delete',
        method: 'post',
        data
    })
}


